import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import {
  getClaimReportCardsApi,
  getTicketsReportLastMonthApi,
  postTicketsReportScheduleApi,
} from 'api/reports';
import type {
  GetClaimReportParamsDTO,
  GetClaimReportsResponseDTO,
  GetTicketsReportLastMonthParamsDTO,
  GetTicketsReportLastMonthResponseDTO,
  GetTicketsReportScheduleParamsDTO,
  GetTicketsReportScheduleResponseDTO,
} from 'declarations/dto/reports';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchTicketsReportLastMonth = (
  params: GetTicketsReportLastMonthParamsDTO
): UseQueryResult<GetTicketsReportLastMonthResponseDTO, ApiErrorI> =>
  useQuery<GetTicketsReportLastMonthResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchTicketsReportLastMonth, params],
    (): Promise<GetTicketsReportLastMonthResponseDTO> => getTicketsReportLastMonthApi(params),
    { staleTime: RequestStaleTimeE.TicketsReportLastMonth }
  );

export const useFetchClaimReports = (
  params: GetClaimReportParamsDTO
): UseQueryResult<GetClaimReportsResponseDTO, ApiErrorI> =>
  useQuery<GetClaimReportsResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchClaimReportCards, params],
    (): Promise<GetClaimReportsResponseDTO> => getClaimReportCardsApi(params),
    { staleTime: RequestStaleTimeE.ClaimReportCards }
  );

export const useFetchScheduleReports = (
  params: GetTicketsReportScheduleParamsDTO
): UseQueryResult<GetTicketsReportScheduleResponseDTO, ApiErrorI> =>
  useQuery<GetTicketsReportScheduleResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchClaimReportCards, params],
    (): Promise<GetTicketsReportScheduleResponseDTO> => postTicketsReportScheduleApi(params),
    { staleTime: RequestStaleTimeE.ClaimReportCards }
  );
